
<script>
    const BASE_URL = "https://forum.gamemorefun.net/api";
    export default {
        BASE_URL
    };
</script>